import React from "react";
import { RouteComponentProps } from "@reach/router";
import { OnboardingModal } from "pages/Onboarding/OnBoardingModal";

const ViewProfile: React.FC<RouteComponentProps> = () => {
  return (
    <div className="WidthContent HeightContent">
      <OnboardingModal />
    </div>
  );
};

export default ViewProfile;
